module.exports = __webpack_public_path__ + "static/media/R-360HD_EC.a8b7fd42.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/R-360HD_EC.png
// module id = 2106
// module chunks = 0